import React from 'react';
import Backend from '../../../Layouts/Backend';
import { NavButton } from '../../../UI/Common';
import Datagrid from '../../../UI/Datagrid';
import { withTranslation } from 'react-i18next';
import DeleteRecord from '../../../UI/DeleteRecord';

class UnitsPage extends React.Component {
  render() {
    const { t, loading, units, datagridProps, openModal } = this.props;
    return (
      <Backend>
        <div className="content-inner">
          <DeleteRecord
            isOpen={openModal}
            title="Delete unit"
            body="Are you sure you want to delete this unit?"
            onCancel={() => this.props.onCancel()}
            onConfirm={() => this.props.onDeleteUnit()}
          />
          <NavButton id="new-unit-btn" to="/configure/units/new-unit">
            <i className="md-icon">add</i>
            {t('New Unit')}
          </NavButton>
          <Datagrid
            datagridProps={{
              keyField: 'id',
              data: units,
              loading,
              ...datagridProps,
            }}
            ctxMenuOptions={this.props.ctxMenuOptions}
            exportProps={{
              fileName: 'Units',
            }}
          />
        </div>
      </Backend>
    );
  }
}

export default withTranslation('app')(UnitsPage);
